import { Icon } from '@iconify/react';
import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../utils/context/useAuthContext';

const AgentUploadFile = () => {
  const theme = useTheme();

  const navigate = useNavigate();

  const { user } = useAuth();

  const fullName = user?.name;

  return (
    <Stack spacing={'20px'}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          sx={{ cursor: 'pointer' }}
          onClick={() => {
            navigate(-1);
          }}
        >
          <Icon icon="lets-icons:refund-back" />
          <Typography>חזרה</Typography>
        </Stack>
        <Typography
          fontSize="30px"
          fontWeight="700"
          fontFamily={'AlmoniDL'}
          textAlign={'right'}
          dir="rtl"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {fullName}, שלום
        </Typography>
      </Box>
      <Divider
        sx={{
          width: '100%',
          height: '1px',
          backgroundColor: theme.palette.dark.border,
        }}
      />
      <Outlet />
    </Stack>
  );
};

export default AgentUploadFile;
